var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9346_17778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8994 20H6.10059C5.94516 20 5.79613 19.9383 5.68629 19.8284L0.171641 14.3138C0.0617188 14.2039 0 14.0548 0 13.8994V6.10059C0 5.94516 0.0617188 5.79613 0.171641 5.68629L5.68625 0.171641C5.79613 0.0617188 5.94516 0 6.10059 0H13.8994C14.0548 0 14.2039 0.0617188 14.3137 0.171641L19.8284 5.68629C19.9382 5.79617 20 5.9452 20 6.10059V13.8994C20 14.0548 19.9383 14.2039 19.8284 14.3137L14.3138 19.8284C14.2039 19.9383 14.0548 20 13.8994 20Z",
    fill: "#FF674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8994 20C14.0548 20 14.2039 19.9383 14.3137 19.8284L19.8284 14.3137C19.9382 14.2038 20 14.0548 20 13.8994V6.10059C20 5.94516 19.9383 5.79613 19.8284 5.68629L14.3138 0.171641C14.2039 0.0617188 14.0548 0 13.8994 0H10V20H13.8994Z",
    fill: "#F2472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1497 12.4014H8.85033C8.6199 12.4014 8.43025 12.22 8.41997 11.9898L8.04775 3.64797C8.02587 3.15758 8.41755 2.74805 8.90841 2.74805H11.0916C11.5824 2.74805 11.9741 3.15758 11.9522 3.64797L11.58 11.9898C11.5697 12.22 11.3801 12.4014 11.1497 12.4014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99914 17.2522C9.13668 17.2522 8.4375 16.553 8.4375 15.6905C8.4375 14.8281 9.13668 14.1289 9.99914 14.1289C10.8616 14.1289 11.5608 14.8281 11.5608 15.6905C11.5608 16.553 10.8616 17.2522 9.99914 17.2522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1309V17.2541C10.8624 17.254 11.5615 16.5549 11.5615 15.6925V15.6925C11.5614 14.8301 10.8624 14.131 10 14.1309Z",
    fill: "#FFEDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0914 2.74805H10V12.4014H11.1495C11.3799 12.4014 11.5696 12.22 11.5798 11.9898L11.9521 3.64797C11.974 3.15758 11.5823 2.74805 11.0914 2.74805Z",
    fill: "#FFEDCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9346_17778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningImage);
export default __webpack_public_path__ + "static/media/warning_image.ace3c58c7f108440f02506087caf7990.svg";
export { ForwardRef as ReactComponent };